import React, { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import loadRemoteModule from '../../utils/loadRemoteModule';

type LazyComponentProps = {
  url: string;
  module: string;
  scope: string;
  children: ReactNode;
};

const LazyComponent: FC<LazyComponentProps> = React.memo(
  ({ url, module, scope, children, ...props }) => {
    const Component = React.lazy(() =>
      loadRemoteModule({ url, module, scope })
    );

    return <Component {...props}>{children}</Component>;
  }
);

LazyComponent.displayName = 'LazyComponent';
LazyComponent.propTypes = {
  url: PropTypes.string.isRequired,
  module: PropTypes.string.isRequired,
  scope: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default LazyComponent;
